




















import {Component, Emit, Prop, Vue} from 'vue-property-decorator';

@Component
export default class StatusConfirmation extends Vue {
  @Prop() isVisible!: boolean;

  @Emit('confirmed')
  private emitConfirmation(confirmed: boolean) {
    return confirmed;
  }
}
